import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTOPTIONDETAIL,
  DELETE_PRODUCTOPTIONDETAIL,
  UPDATE_PRODUCTOPTIONDETAIL,
  ADD_NEW_PRODUCTOPTIONDETAIL,
} from "./actionType";

import {
  getProductOptionDetailSuccess,
  getProductOptionDetailFail,
  deleteProductOptionDetailSuccess,
  deleteProductOptionDetailFail,
  updateProductOptionDetailSuccess,
  updateProductOptionDetailFail,
  addProductOptionDetailSuccess,
  addProductOptionDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveProductOptionDetailApi,
  getProductOptionDetailApi,
  updateProductOptionDetailApi,
  deleteProductOptionDetailApi,
  addNewProductOptionDetailApi
} from "../../helpers/backend_helper";

function* getProductOptionDetail({ payload: productOptionDetail }) {
  try {
    const response = yield call(getProductOptionDetailApi, productOptionDetail);
    yield put(getProductOptionDetailSuccess(GET_PRODUCTOPTIONDETAIL, response.data));
  } catch (error) {
    yield put(getProductOptionDetailFail(GET_PRODUCTOPTIONDETAIL, error));
  }
}

function* onUpdateProductOptionDetail({ payload: productOptionDetail }) {
  try {
    if (productOptionDetail.setApprove) {
      const response = yield call(approveProductOptionDetailApi, productOptionDetail);
      yield put(updateProductOptionDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductOptionDetailApi, productOptionDetail);
      yield put(updateProductOptionDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductOptionDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductOptionDetail({ payload: productOptionDetail }) {
  try {
    const response = yield call(deleteProductOptionDetailApi, productOptionDetail);
    yield put(deleteProductOptionDetailSuccess({ productOptionDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductOptionDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductOptionDetail({ payload: productOptionDetail }) {
  try {
    const response = yield call(addNewProductOptionDetailApi, productOptionDetail);
    yield put(addProductOptionDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductOptionDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductOptionDetail() {
  yield takeEvery(GET_PRODUCTOPTIONDETAIL, getProductOptionDetail);
}

export function* watchUpdateProductOptionDetail() {
  yield takeEvery(UPDATE_PRODUCTOPTIONDETAIL, onUpdateProductOptionDetail);
}

export function* watchDeleteProductOptionDetail() {
  yield takeEvery(DELETE_PRODUCTOPTIONDETAIL, onDeleteProductOptionDetail);
}

export function* watchAddNewProductOptionDetail() {
  yield takeEvery(ADD_NEW_PRODUCTOPTIONDETAIL, onAddNewProductOptionDetail);
}

function* productOptionDetailSaga() {
  yield all([
    fork(watchGetProductOptionDetail),
    fork(watchDeleteProductOptionDetail),
    fork(watchUpdateProductOptionDetail),
    fork(watchAddNewProductOptionDetail)
  ]);
}

export default productOptionDetailSaga;
